jQuery(document).on('nfFormReady', function (e, layoutView) {
    function validateField(input, fieldModel) {
        const fieldValue = input.val();
        const fieldType = fieldModel.get('type'); // Тип поля (text, email, number тощо)

        // Логіка для поля "required"
        if (fieldModel.get('required') && !fieldValue) {
            Backbone.Radio.channel('fields').request('add:error', fieldModel.get('id'), 'required-error', 'Dies ist ein Pflichtfeld!');
            return;
        } else {
            Backbone.Radio.channel('fields').request('remove:error', fieldModel.get('id'), 'required-error');
        }

        // Якщо все пройшло успішно, додаємо успішний клас
        Backbone.Radio.channel('fields').request('remove:error', fieldModel.get('id'), 'field-error');
        input.addClass('nf-pass');
        input.parents('.field-wrap').addClass('nf-pass');
    }

    const UniversalFieldValidator = Marionette.Object.extend({
        initialize: function () {
            // Відслідковуємо зміну будь-якого поля
            this.listenTo(nfRadio.channel('fields'), 'change:field', this.validateAllFields);
        },

        validateAllFields: function (input, fieldModel) {
            // Викликаємо валідацію для будь-якого поля
            validateField(input, fieldModel);
        }
    });

    // Ініціалізуємо загальний валідатор
    new UniversalFieldValidator();
});
